import getVideoId from 'get-video-id'
import slugify from 'slugify'

type VideoParams = { id: string; service: string }

export const getVideoIDFromUrl = (url: string, { id, service }: VideoParams = getVideoId(url)) => {
  return { id, service }
}

type ElementsAllowed = 'p' | 'a'

export const getTrimmedExcerpt = (el: ElementsAllowed, excerpt?: { html: string }, limit: number = 95) => {
  let result = excerpt

  if (excerpt) {
    const { html } = excerpt
    const onlyText = html.substring(html.indexOf(`<${el}>`) + (el.length + 2), html.indexOf(`</${el}>`))
    if (onlyText.length > limit) {
      result = { html: `<${el}>${onlyText.slice(0, limit).trim()}...</${el}>` }
    }
  }
  return result && result.html.length > limit * 1.5 ? { html: '' } : result
}

/**
 *  this function returns 3 different orders
 *  depending on random number.
 *  This should be random enough
 */
export const pseudoRandom = <T>(arr: T[], customSort: (a: T, b: T) => number) => {
  const MAX = 100
  const rndNum = Math.floor(Math.random() * Math.floor(MAX))
  if (rndNum < MAX / 4) {
    return arr.reverse()
  } else if (rndNum >= MAX / 4 && rndNum < MAX / 2) {
    return arr
  } else return arr.sort(customSort)
}

export const getUniqueTags = (array: { tags: string[] }[]) => {
  const tagArray: string[] = []
  array.forEach(obj => {
    obj.tags.forEach(tag => {
      if (!tagArray.includes(tag.toLocaleLowerCase())) {
        tagArray.push(tag.toLocaleLowerCase())
      }
    })
  })
  tagArray.sort((a, b) => {
    if (a > b) return 1
    if (a < b) return -1
    return 0
  })
  return tagArray
}

export const filterByTags = <T extends { tags: string[] }>(tags: string[], array: T[]) => {
  const cleanedTags = tags.map(tag => slugify(tag, { lower: true }))
  if (tags.length) {
    return array.filter(obj => obj.tags.some(tag => cleanedTags.includes(slugify(tag, { lower: true }))))
  } else return array
}
